import VPAIDInterface from './VPAIDInterface';

export const InterfaceTypes = {
  VPAID: 'vpaid'
};

export const getHostInterface = type => {
  switch(type) {
    case InterfaceTypes.VPAID:
      return new VPAIDInterface();
  }
};


// WEBPACK FOOTER //
// ./src/HostInterface/InterfaceFactory.js